export const DEFAULT_PAGE_SIZE = 40;

export const DEFAULT_HIDDEN_PASSWORD_TEXT = '***************';

export const FILTERED_COMPANY_ROLES = [
  'BUSINESS_ANALYST',
  'DIRECTOR',
  'QA_ENGINEER',
  'SCRUM_MASTER',
  'MANAGER',
  'PRODUCT_MANAGER',
  'PRODUCT_OWNER',
  'EXECUTIVE_BOARD_MEMBER',
  'PROJECT_MANAGER',
  'DEVOPS_ENGINEER'
];

export const FREE_ADDONS = [
  'AzureDevops',
  'Bitbucket',
  'BitbucketCloud',
  'GitHub',
  'GitLab',
  'Sonar',
  'TestiniumCloud',
  'NewRelic',
  'Jira'
];

export const HOURS = ['00','01','02','03','04','05','06','07','08','09','10','11','12','13','14','15','16','17','18','19','20','21','22','23'];
export const MINUTES = ['00','15','30','45'];
export const TIMEZONE = ['GMT+0','GMT+1','GMT+2','GMT+3','GMT+4','GMT+5','GMT+6','GMT+7','GMT+8','GMT+9','GMT+10','GMT+11','GMT+12'];

